import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Schedule } from "../models/schedule";
import { Value } from "../models/value";

@Injectable()
export class ScheduleService {
  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * Create a schedule with an API call
   * @param {Schedule} schedule
   * @returns {Observable<any>}
   */
  saveSchedule(schedule: Schedule) {
    const data = {
      languageIds: schedule.languages.map((language) => language.id),
      channelIds: schedule.channels.map((channel) => channel.id),
      startTimestamp: schedule.startTimestamp,
      endTimestamp: schedule.endTimestamp,
      email: schedule.email,
    };
    return this.apiService.post("MagicBox/CreateSchedule", data);
  }

  /**
   * Fetch all MAgic Box Scheduling from the API
   * @returns {Observable<any>}
   */
  getAllMagicBoxSchedule() {
    return this.apiService.get("MagicBox/GetAllMagicBoxSchedule").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new Value(value));
      }
    });
  }

  checkMagicBoxScheduleAvailibility(schedule: Schedule) {
    const data = {
      languageIds: schedule.languages.map((language) => language.id),
      channelIds: schedule.channels.map((channel) => channel.id),
      startTimestamp: schedule.startTimestamp,
      endTimestamp: schedule.endTimestamp,
    };
    return this.apiService.post("MagicBox/CheckMagicBoxAvailibility", data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/schedule.service.ts